import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingContact from "./components/FloatingContact";

import Home from "./pages/Home";
import Mireasa from "./pages/Mireasa";
import Revelion from "./pages/Revelion";
import Ocazie from "./pages/Ocazie";
import Cununie from "./pages/Cununie";
import Domnisoara from "./pages/Domnisoara";
import Cocktail from "./pages/Cocktail";
import Seara from "./pages/Seara";
import Portofoliu from "./pages/Portofoliu";
import Contact from "./pages/Contact";
import { Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function App() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Navbar />

      {/* Let pages control their own spacing/containers */}
      <main
        className={isHome ? "" : "max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-10"}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rochii/mireasa" element={<Mireasa />} />
          <Route path="/rochii/revelion" element={<Revelion />} />
          <Route path="/rochii/ocazie" element={<Ocazie />} />
          <Route path="/rochii/cununie-civila" element={<Cununie />} />
          <Route path="/rochii/domnisoara-de-onoare" element={<Domnisoara />} />
          <Route path="/rochii/cocktail" element={<Cocktail />} />
          <Route path="/rochii/seara" element={<Seara />} />
          <Route path="/portofoliu" element={<Portofoliu />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <Footer />
      <FloatingContact />
    </div>
  );
}
